// src/components/layout/ProtectedRoute.jsx
import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { showToast } from '../../utils/helpers';
import LandingPage from '../auth/LandingPage';
import { useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { currentUser, loading, logout } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Check if token exists but user is null (indicating invalid token)
    const token = localStorage.getItem('_t');
    if (token && !loading && !currentUser) {
      console.log('Token exists but no user, likely invalid token');
      showToast('Your session has expired. Please login again.', 'error');
      logout();
    }
  }, [currentUser, loading, logout]);

  // Check if current route is a store route
  const isStoreRoute = () => {
    return location.pathname.startsWith('/s/');
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // If it's a store route, always render children (allow public access to store pages)
  if (isStoreRoute()) {
    return children;
  }

  // If not authenticated and not a store route, show landing page
  if (!currentUser) {
    return <LandingPage />;
  }

  // If authenticated, render the protected content
  return children;
};

export default ProtectedRoute;